import { QueryClient, useQuery } from '@tanstack/react-query';
import { useFullAppPrefill } from '../hooks/usePrefillQuery';
import { useWidgetsQuery } from '@hooks/useWidgetsQuery';
import { Widgets } from '@types';
import { instance } from '@utils/fetch';
import { config } from '../../../config';

export const fullappLoader =
    (queryClient: QueryClient) =>
    async ({ params }: { params: { loanNumber: string } }) => {
        const query = useFullAppPrefill({ loanNumber: params.loanNumber });
        return queryClient.getQueryData(query.queryKey) ?? (await queryClient.fetchQuery(query));
    };

export const useDashboardWidgetsQuery = () => ({
    queryKey: ['widgets'],
    queryFn: async () =>
        await instance.request({
            url: `${config.env('awsUrl')}/api/v1/selfserv/customers/widgets?refresh=true`,
            method: 'get'
        }),
    select: ({ data }: any) => data,
    useErrorBoundary: true
});

export const dashboardLoader =
    (queryClient: QueryClient) =>
    async ({ params }: { params: { loanNumber: string } }) => {
        const query = useDashboardWidgetsQuery();
        return queryClient.getQueryData(query.queryKey) ?? (await queryClient.fetchQuery(query));
    };
